import { UpdateGroupClassAvailabilityInput } from 'types/group-class'
import { putApiRequest } from 'utils/fetch-helper'

export async function softDeleteGroupClassAvailability(
    availability_id: string
) {
    return await putApiRequest(
        `/v1/group_class_availabilities/soft-delete/${availability_id}`
    )
}

export async function updateGroupClassAvailability(
    updates: UpdateGroupClassAvailabilityInput
) {
    return await putApiRequest(
        `/v1/group_class_availabilities/${updates.id}`,
        updates
    )
}
